<template>
  <v-btn @click="$emit('click')"
         class="top_menu__button__list-title text-h6 text-uppercase text-white"
         type="text"
  >
    Войти
  </v-btn>
</template>

<script>
export default {
  name: 'LoginButton',
  emits: ['click'],
}
</script>
